import * as React from 'react';

export const useModal = (initialIsOpen = false) => {
  const [isModalOpen, setIsModalOpen] = React.useState(initialIsOpen);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return { openModal, closeModal, isModalOpen };
};
